import { render, staticRenderFns } from "./TenderRow.vue?vue&type=template&id=322c2753&"
import script from "./TenderRow.vue?vue&type=script&lang=js&"
export * from "./TenderRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports